import React from "react";

import { useAppAnalyticsEffects } from "app/hooks/useAppAnalyticsEffects";
import { useAppBackgroundEffects } from "app/hooks/useAppBackgroundEffects";
import { useAppPWAStateEffects } from "app/hooks/useAppPWAStateEffects";
import { useAuthStateEffects } from "app/hooks/useAuthStateEffects";
import { useFetchNextOrder } from "app/hooks/useFetchNextOrder";
import { useLogoutWhenUnauthorized } from "app/hooks/useLogoutWhenUnauthorized";

type AppEffectsProviderProps = {
  children: React.ReactNode;
};

export function AppEffectsProvider({ children }: AppEffectsProviderProps) {
  useAuthStateEffects();
  useAppAnalyticsEffects();
  useAppPWAStateEffects();
  useFetchNextOrder();
  useAppBackgroundEffects();
  useLogoutWhenUnauthorized();

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
}
